import React from 'react';
import {connect} from "react-redux";
import GlobalErrorComponent from "../components/GlobalErrorComponent";
import {withRouter} from "react-router";

class GlobalErrorContainer extends React.Component {


	componentWillMount() {
		this.unlisten = this.props.history.listen((location, action) => {
			this.props.clearError();
		});
	}
	componentWillUnmount() {
		this.unlisten();
	}

	render() {
		return <GlobalErrorComponent messageKey={this.props.messageKey}/>
	}

}

export default withRouter(connect(
	(state) => {
		return {
			messageKey: state.errors.messageKey
		}
	},
	(dispatch) => {
		return {
			clearError: () => {
				dispatch({
					type: 'CLEAR_ERROR'
				})
			}
		}
	}
)(GlobalErrorContainer))